import React, {useState} from "react";
import SimpleBar from 'simplebar-react';
import {Link, useLocation} from "react-router-dom";
import {CSSTransition} from 'react-transition-group';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
  faBook,
  faBoxOpen,
  faChartPie,
  faCheck,
  faDoorOpen,
  faFileAlt,
  faHistory,
  faInbox,
  faLanguage,
  faSignOutAlt,
  faTable,
  faTasks,
  faUser,
  faUserEdit,
} from "@fortawesome/free-solid-svg-icons";
import {
  Accordion,
  Badge,
  Button,
  Dropdown,
  Image,
  Modal,
  Nav,
  Navbar,
  ToggleButton,
  ToggleButtonGroup
} from '@themesberg/react-bootstrap';
import SigninPage from "../pages/examples/SigninPage";
import SignupPage from "../pages/examples/SignupPage";
import LockPage from "../pages/examples/LockPage";
import ForgotPasswordPage from "../pages/examples/ForgotPasswordPage";
import ResetPasswordPage from "../pages/examples/ResetPasswordPage";
import NotFoundPage from "../pages/examples/ExceptionPage";
import ServerErrorPage from "../pages/examples/ServerErrorPage";
import BootstrapTablePage from "../pages/tables/BootstrapTablePage";
import DocsOverviewPage from "../pages/documentation/DocsOverviewPage";
import DocsDownloadPage from "../pages/documentation/DocsDownloadPage";
import DocsQuickStartPage from "../pages/documentation/DocsQuickStartPage";
import DocsLicensePage from "../pages/documentation/DocsLicensePage";
import DocsFolderStructure from "../pages/documentation/DocsFolderStructurePage";
import DocsChangelog from "../pages/documentation/DocsChangelogPage";
import AccordionPage from "../pages/components/AccordionPage";
import AlertPage from "../pages/components/AlertPage";
import BadgePage from "../pages/components/BadgePage";
import BreadcrumbPage from "../pages/components/BreadcrumbPage";
import FormPage from "../pages/components/FormPage";
import ButtonPage from "../pages/components/ButtonPage";
import ModalPage from "../pages/components/ModalPage";
import NavPage from "../pages/components/NavPage";
import NavbarPage from "../pages/components/NavbarPage";
import PaginationPage from "../pages/components/PaginationPage";
import PopoverPage from "../pages/components/PopoverPage";
import ProgressPage from "../pages/components/ProgressPage";
import TablePage from "../pages/components/TablePage";
import TabPage from "../pages/components/TabPage";
import TooltipPage from "../pages/components/TooltipPage";
import ToastPage from "../pages/components/ToastPage";
import DocsBuildPage from "../pages/documentation/DocsBuildPage";
import label from 'enqc-utilities/src/label/Label'
import DashboardPage from "../pages/dashboard/DashboardPage";
import ProfilePage from "../pages/config/ProfilePage";
import UserActivityPage from "../pages/session/UserActivityPage";
import UserDevicePage from "../pages/session/UserDevicePage";
import {getData} from "../utils/StorageUtil";
import Global from "../utils/Global";
import {AuthConsumer} from "../context/AuthContext";
import {COPYRIGHT} from "../Variable";
import ModelPage from "../pages/model/ModelPage";
import {isEmpty} from "enqc-utilities/src/utils/Utilities";
import AssemblyPage from "../pages/business/AssemblyPage";
import UserPage from "../pages/management/UserPage";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import {storeData} from "enqc-utilities/src/utils/StorageUtil";

const showExample = false;

export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const [logoutDialogShow, setLogoutDialogShow] = useState(false);
  const showClass = show ? "show" : "";

  const onCollapse = (element) => {
    setShow(!show)
  };
  const controlLogoutDialog = () =>{
    setLogoutDialogShow(!logoutDialogShow)
  }

  const user = getData(Global.USER)
  const registration = user.registration?user.registration:{}


  const CollapsableNavItem = (props) => {
    const {members, eventKey, title, icon, children = null } = props;
    let defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";
    // alert(JSON.stringify(window.location))
    if(members){
      members.forEach((member)=>{
        if(pathname.indexOf(member) !== -1){
          defaultKey = eventKey
        }
      })
    }

    return (
      <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button as={Nav.Link} className="d-flex justify-content-between align-items-center">
            <span>
              <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span>
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column">
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = (props) => {
    const { title, link, external, target, icon, image, badgeText, badgeBg = "secondary", badgeColor = "primary", onClick} = props;
    const classNames = badgeText ? "d-flex justify-content-start align-items-center justify-content-between" : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => {
        if(!onClick){
          setShow(false)
          return ;
        }
        onClick()
      }}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span> : null}
            {image ? <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" /> : null}

            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };


  let languageKey = getData(Global.LANGUAGE)
  if(isEmpty(languageKey)){
    languageKey = Global.DEFAULT_LANGUAGE
  }

  const LogoutModal = (props) =>{
    const {logout} = props
    return (
        <React.Fragment>
          <Modal size="sm" className="p-5" as={Modal.Dialog} centered show={logoutDialogShow} onHide={()=>{}}>
            <Modal.Header style={{display:"block",textAlign:'center'}}>
              <h4>{label.LogoutConfirmation}</h4>
            </Modal.Header>
            <Modal.Body style={{display:"block",textAlign:'center'}}>
              <img style={{width:'50%'}} src={ApplicationIcons.Icons.signout}></img>
            </Modal.Body>
            <Modal.Body style={{display:"block",textAlign:'center'}}>
              <h5 className="text-danger bold">{label.DoYouWantToLogoutFormThiApplication}</h5>
            </Modal.Body>
            <Modal.Footer>
              <Button size="sm" variant="success" onClick={event => {
                controlLogoutDialog()
              }}>
                <FontAwesomeIcon icon={faCheck} className="me-2" />  {label.Cancel}
              </Button>
              <Button size="sm" variant="danger" className="ms-auto"
                      onClick={()=>{
                        controlLogoutDialog()
                        logout()
                      }}>
                {label.Logout}
              </Button>
            </Modal.Footer>
          </Modal>
        </React.Fragment>
    )
  }

  return (
      <AuthConsumer>
        {({ isAuth, user, logout}) => (
            <>
              <LogoutModal logout={logout}/>
              <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none fixed-top d-flex align-items-center align-content-center">
                <Navbar.Brand className="me-lg-5 d-flex  align-items-center align-content-center" as={Link} to={DashboardPage.ENDPOINT}>
                  <Image src={ApplicationIcons.Icons.abacusIcon} className="navbar-brand-light" />
                  &nbsp;
                  <h4 className="text-white m-0 ps-3 pt-1 align-items-center align-content-center text-uppercase">{label.AppNameAssembler}</h4>
                </Navbar.Brand>
                <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
                  <span className="navbar-toggler-icon" />
                </Navbar.Toggle>
              </Navbar>
              <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
                <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white w-80`}>
                  <div className="sidebar-inner px-4 pt-3">
                    <Nav className="flex-column pt-3 pt-md-0">
                      <NavItem className="bg-yellow" title={label.AppNameAssembler} link={"/"} image={ApplicationIcons.Icons.abacusIcon} />
                      <NavItem title={label.Dashboard} link={DashboardPage.ENDPOINT} icon={faChartPie} />
                      <NavItem title={label.Assemblies} icon={faTasks} link={AssemblyPage.ENDPOINT} />
                      <NavItem title={label.Models} icon={faInbox} link={ModelPage.ENDPOINT} />
                      {/*<NavItem title={label.Assemblies} icon={faToolbox} link={AssemblyDetailPage.ENDPOINT} />*/}
                      <NavItem title={label.User} icon={faUser} link={UserPage.ENDPOINT} />
                      <CollapsableNavItem
                          members={[UserDevicePage.ENDPOINT, UserDevicePage.ENDPOINT, UserActivityPage.ENDPOINT]}
                          eventKey={label.SessionAndActivity}
                          title={label.SessionAndActivity}
                          icon={faHistory}>
                        <NavItem title={label.Devices} link={UserDevicePage.ENDPOINT} />
                        <NavItem title={label.UserActivity} link={UserActivityPage.ENDPOINT} />
                      </CollapsableNavItem>
                      {
                        showExample?(
                            <>
                              <CollapsableNavItem eventKey="tables/" title="TablePage" icon={faTable}>
                                <NavItem title="Bootstrap Table" link={BootstrapTablePage.ENDPOINT} />
                              </CollapsableNavItem>

                              <CollapsableNavItem eventKey="examples/" title="Page Examples" icon={faFileAlt}>
                                <NavItem title="Sign In" link={SigninPage.ENDPOINT} />
                                <NavItem title="Sign Up" link={SignupPage.ENDPOINT} />
                                <NavItem title="Forgot password" link={ForgotPasswordPage.ENDPOINT} />
                                <NavItem title="Reset password" link={ResetPasswordPage.ENDPOINT} />
                                <NavItem title="Lock" link={LockPage.ENDPOINT} />
                                <NavItem title="404 Not Found" link={NotFoundPage.ENDPOINT} />
                                <NavItem title="500 Server Error" link={ServerErrorPage.ENDPOINT} />
                              </CollapsableNavItem>
                            </>
                        ):(null)
                      }

                      <Dropdown.Divider className="my-3 border-white" />
                      {
                        showExample?(
                            <>
                              <CollapsableNavItem eventKey="documentation/" title="Getting Started" icon={faBook}>
                                <NavItem title="Overview" link={DocsOverviewPage.ENDPOINT} />
                                <NavItem title="Download" link={DocsDownloadPage.ENDPOINT} />
                                <NavItem title="Quick Start" link={DocsQuickStartPage.ENDPOINT} />
                                <NavItem title="License" link={DocsLicensePage.ENDPOINT} />
                                <NavItem title="Folder Structure" link={DocsFolderStructure.ENDPOINT} />
                                <NavItem title="Build Tools" link={DocsBuildPage.ENDPOINT} />
                                <NavItem title="Changelog" link={DocsChangelog.path} />
                              </CollapsableNavItem>
                              <CollapsableNavItem eventKey="components/" title="Components" icon={faBoxOpen}>
                                <NavItem title="Accordion" link={AccordionPage.ENDPOINT} />
                                <NavItem title="Alert" link={AlertPage.ENDPOINT} />
                                <NavItem title="Badges" link={BadgePage.ENDPOINT} />
                                <NavItem external title="Widgets" link="https://demo.themesberg.com/volt-pro-react/#/components/widgets" target="_blank" badgeText="Pro" />
                                <NavItem title="Breadcrumbs" link={BreadcrumbPage.ENDPOINT} />
                                <NavItem title="Buttons" link={ButtonPage.ENDPOINT} />
                                <NavItem title="Forms" link={FormPage.ENDPOINT} />
                                <NavItem title="Modals" link={ModalPage.ENDPOINT} />
                                <NavItem title="Navbars" link={NavbarPage.ENDPOINT} />
                                <NavItem title="Navs" link={NavPage.ENDPOINT} />
                                <NavItem title="Pagination" link={PaginationPage.ENDPOINT} />
                                <NavItem title="Popovers" link={PopoverPage.ENDPOINT} />
                                <NavItem title="Progress" link={ProgressPage.ENDPOINT} />
                                <NavItem title="TablePage" link={TablePage.ENDPOINT} />
                                <NavItem title="Tabs" link={TabPage.ENDPOINT} />
                                <NavItem title="Toasts" link={ToastPage.ENDPOINT} />
                                <NavItem title="Tooltips" link={TooltipPage.ENDPOINT} />
                              </CollapsableNavItem>
                            </>
                        ):(null)
                      }
                      <NavItem title={label.YourProfile} icon={faUserEdit} link={ProfilePage.ENDPOINT} />
                      {registration.followUp?(
                          <NavItem title={label.Logout} icon={faSignOutAlt} link={COPYRIGHT} external={true} onClick={()=>{
                            logout(props)
                          }}/>
                      ):(null)}
                    </Nav>
                    <Nav className="d-block d-sm-none">
                      <div className="d-flex align-items-center align-content-center">
                        <NavItem title={label.Language} icon={faLanguage} link="#" onClick={()=>{}}/>
                        <div className="float-end text-end w-100 align-items-center align-content-center">
                          <ToggleButtonGroup size="sm"
                              type="radio"
                              name="languageOptions"
                              value={languageKey}
                              className="align-content-center align-items-center justify-content-center p-0"
                              onChange={()=>{}}>
                            <ToggleButton
                                className="m-0"
                                size="sm"
                                id="lang-en"
                                value="en"
                                variant="outline-light"
                                onClick={event => {
                                  // let language = LANGUAGE.en
                                  storeData(Global.LANGUAGE, "en")
                                  window.location.reload()
                                }}>
                              &#x1F1EC;&#x1F1E7; {label.EN}
                            </ToggleButton>
                            <ToggleButton
                                className="m-0"
                                size="sm"
                                id="lang-id"
                                value="in"
                                variant="outline-light"
                                onClick={event => {
                                  // let language = LANGUAGE.id
                                  storeData(Global.LANGUAGE, "in")
                                  window.location.reload()
                                }}>
                              &#x1F1EE;&#x1F1E9; {label.ID}
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </div>
                      </div>
                      <NavItem title={label.Logout} icon={faDoorOpen} onClick={()=>{
                        controlLogoutDialog()
                        onCollapse()
                      }} />
                    </Nav>
                  </div>
                </SimpleBar>
              </CSSTransition>
            </>
        )}
      </AuthConsumer>
  );
};
